import { render } from "./CaptchaBox.vue?vue&type=template&id=ac3c1866"
import script from "./CaptchaBox.vue?vue&type=script&lang=js"
export * from "./CaptchaBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__